import { useCallback, useEffect, useState } from 'react';
import { Option } from '../models/formModel';
import useCallApiAndLoad from './useCallApiAndLoad';
import { getSdrSelectList } from '../services/publicService';
import { fetchResponseAdapter } from '../adapters/fetchAdapter';
import { listToSelectOptionAdapter } from '../adapters/listAdapter';
import useAuth from './useAuth';

type SdrRole = 'SDR_RENT' | 'SDR__SALES' | 'SDR_PRESALES';

const useSdrList = (role: SdrRole) => {
  const [sdrs, setSdrs] = useState([]);
  const [isLoadingSdrs, setIsLoadingSdrs] = useState<boolean>(true);
  const [sdrOptions, setSdrOptions] = useState<Option[]>([]);
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const { callEndpoint } = useCallApiAndLoad();

  const loadSdrs = useCallback(async (sdrRole: SdrRole) => {
    const { status, data } = await callEndpoint(
      getSdrSelectList(sdrRole, token),
    );
    if (status === 200) {
      const sdrResponse = fetchResponseAdapter(data);
      setSdrs(sdrResponse.data);
      setSdrOptions(
        listToSelectOptionAdapter(sdrResponse.data, 'id', 'name', false),
      );
      setIsLoadingSdrs(false);
    }
  }, []);

  useEffect(() => {
    loadSdrs(role).catch((e) => console.error(e));
  }, []);

  useEffect(() => {
    if (sdrOptions.length) {
      setIsLoadingSdrs(false);
    }
  }, [sdrOptions]);

  return {
    sdrs,
    sdrOptions,
    loadSdrs,
    isLoadingSdrs,
  };
};

export default useSdrList;
